import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';

export class StringFilterPredicate<T> implements FilterPredicate<T> {

    // eslint-disable-next-line no-useless-constructor
    constructor(
        private readonly valueExtractor: (row: T) => string,
        private readonly filterValue: string[],
    ) {
    }

    isActive(): boolean {
        return this.filterValue.length > 0;
    }

    check(row: T): boolean {
        const rowValue = this.valueExtractor(row);
        return this.filterValue.includes(rowValue);
    }
}
